import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=53be747c&"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53be747c')) {
      api.createRecord('53be747c', component.options)
    } else {
      api.reload('53be747c', component.options)
    }
    module.hot.accept("./SecondaryNavItem.vue?vue&type=template&id=53be747c&", function () {
      api.rerender('53be747c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/SecondaryNavItem.vue"
export default component.exports